import { JsonObject, JsonProperty } from 'json2typescript';
import { BaseObject } from './base-object-model';

@JsonObject('DeliveryWindowConstraintDTO')
export class DeliveryWindowConstraintDTO extends BaseObject {
  @JsonProperty('id', Number, true) id: number = undefined;
  @JsonProperty('vendors', [Number], true) vendors: number[] = undefined;
  @JsonProperty('daysToExtend', Number, true) daysToExtend: number = undefined;
}
